
import fs from 'fs'
import log from 'loglevel'
import { validateAsClass, ValidationResult } from 'joiful'
import deepmerge from 'deepmerge'

import { DeployConfig, PartialDeployConfig, CiConfig, PartialCiConfig, EnvironmentConfig } from './interface'
import { ciConfigDefaults, deployConfigDefaults } from './defaults'


export const loadConfigFile = async (configFile: string): Promise<PartialDeployConfig | PartialCiConfig> => {
    const configPath = `${process.cwd()}/${configFile}`
    if (!fs.existsSync(configPath)) {
        throw Error(`Missing configuration file on path: ${configPath}`)
    }
    const userConfig = requireFunc(configPath)
    return userConfig
}

export const getDeployConfiguration = async (configFile: string): Promise<DeployConfig> => {
    const userConfig = await loadConfigFile(configFile) as PartialDeployConfig
    // Casting type because we validate config below and it should be complete (the validation isn't perfect, but we can assume it's enough)
    // TODO add deepfreeze?
    const deployConfig = deepmerge(deployConfigDefaults, userConfig, { arrayMerge: overrideEmpty }) as DeployConfig
    validateDeployConfiguration(deployConfig)
    return deployConfig
}

export const getCiConfiguration = async (configFile: string): Promise<CiConfig> => {
    const userConfig = await loadConfigFile(configFile) as PartialCiConfig
    // Casting type because we validate config below and it should be complete (the validation isn't perfect, but we can assume it's enough)
    // TODO add deepfreeze?
    const ciConfig = deepmerge(ciConfigDefaults, userConfig, { arrayMerge: overrideEmpty }) as CiConfig
    validateCiConfiguration(ciConfig)
    return ciConfig
}

const validateDeployConfiguration = (deployConfig: DeployConfig) => {
    const validationResult: ValidationResult<DeployConfig> = validateAsClass(deployConfig, DeployConfig)
    // TODO better validation error messages
    log.debug('Config validation result', validationResult)
    if (validationResult.error) {
        throw validationResult.error
    }
}

const validateCiConfiguration = (ciConfig: CiConfig) => {
    const validationResult: ValidationResult<CiConfig> = validateAsClass(ciConfig, CiConfig)
    // TODO better validation error messages
    log.debug('Config validation result', validationResult)
    if (validationResult.error) {
        throw validationResult.error
    }
}

// UTIL
const overrideEmpty = (destinationArray: any[], sourceArray: any[]): any[] => {
    if (sourceArray && sourceArray.length) {
        return sourceArray;
    }
    return destinationArray;
}

export const getEnvironmentConfig = (deployConfig: DeployConfig, environmentName: string): EnvironmentConfig => {
    const environmentConfig = deployConfig.environments.find(environmentConfig => {
        const { environmentName: name } = environmentConfig
        return name === environmentName
    })
    return environmentConfig
}

// // Webpack safe require
const requireFunc = typeof __webpack_require__ === 'function' ? __non_webpack_require__ : require;
